import React from 'react';
import Img from 'react-cool-img';
import styled from 'styled-components';
import { SortBy } from 'spw-components/collab/types';
import NoSort from 'spw-static/images/no-sort.svg';
import SortAsc from 'spw-static/images/sort-asc.svg';
import SortDesc from 'spw-static/images/sort-desc.svg';

const Container = styled.div`
  cursor: pointer;
  height: 20px;
  img {
    height: 20px;
  }
`;

type Props = {
  value?: string;
  sortBy?: SortBy;
  onClick?: () => void;
  testingId?: string;
};

const getSortIcon = (value: string, sortBy: SortBy) => {
  if (sortBy?.column !== value || value === undefined) {
    return NoSort;
  }
  if (sortBy?.direction.toUpperCase() === 'ASC') {
    return SortAsc;
  }
  return SortDesc;
};

function SortButton({ value, sortBy, onClick, testingId }: Props) {
  return (
    <Container>
      <Img
        onClick={onClick}
        src={getSortIcon(value, sortBy)}
        alt="sort"
        data-testid={testingId}
        aria-label={testingId}
      />
    </Container>
  );
}

export default SortButton;
